import TokenPageBase from '../../../components/views/NFTs/elements/token/TokenPageBase';
function TokenGeneral() {
  // const { tokenContractAddress, tokenId } = useParams();
  return <TokenPageBase useCase="" />;
}

export default TokenGeneral;
